import { useCustomerPortoIsValidData } from '@/core/domain/people/Customers/Customers.hooks';
import { Alert, Button, Skeleton } from 'antd';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export interface PortoIsValidCustomerCallback {
  isValidCustomer?: boolean;
  isLoading: boolean;
}

interface Props {
  customerId?: number;
  description: string;
  onCallback?: (data: PortoIsValidCustomerCallback) => void;
}

export default function PortoIsValidCustomer(props: Props) {
  const customerPortoIsValidData = useCustomerPortoIsValidData(
    props.customerId,
  );

  const history = useHistory();

  useEffect(() => {
    if (props.onCallback)
      props.onCallback({
        isValidCustomer: customerPortoIsValidData.data?.isValidPortoCustomer,
        isLoading: customerPortoIsValidData.isLoading,
      });
  }, [
    customerPortoIsValidData.data?.isValidPortoCustomer,
    customerPortoIsValidData.isLoading,
  ]);

  if (
    !props.customerId ||
    (!customerPortoIsValidData.isLoading &&
      customerPortoIsValidData.data?.isValidPortoCustomer)
  ) {
    return null;
  }

  return (
    <Skeleton loading={customerPortoIsValidData.isLoading}>
      <Alert
        type="warning"
        description={
          <div style={{ textAlign: 'left' }}>
            <strong>O cliente tem dados incompletos</strong>
            <p>{props.description}</p>
            <p>Campos que precisam ser preenchido:</p>
            <ul>
              {customerPortoIsValidData.data?.missingFields.map(
                (field, key) => (
                  <li key={key}>{field}</li>
                ),
              )}
            </ul>
            <Button
              type="primary"
              onClick={() =>
                history.push(`/app/customers/${props.customerId}/general`)
              }
            >
              Ajustar dados
            </Button>
          </div>
        }
      />
    </Skeleton>
  );
}
